import { useState } from 'react';
import { ArrowLeftIcon, ArrowRightIcon } from 'icons';

import { blokTestConst } from 'modules/blok-test';

interface IOption {
  label: string;
}

interface IProps {
  type?: string;
  options: IOption[];
  onChange?: (newIndex: string) => void;
  initialIndex?: number;
  labelPrefix?: string;
}

const Segmented: React.FC<IProps> = ({ options, onChange, initialIndex = 0, labelPrefix = 'Fan', type }) => {
  const [selectedIndex, setSelectedIndex] = useState(initialIndex);

  const handlePrevious = () => {
    if (selectedIndex > 0) {
      const newIndex = selectedIndex - 1;

      setSelectedIndex(newIndex);
      onChange?.(newIndex.toString());
    }
  };

  const handleNext = () => {
    if (selectedIndex < options.length - 1) {
      const newIndex = selectedIndex + 1;

      setSelectedIndex(newIndex);
      onChange?.(newIndex.toString());
    }
  };

  return (
    <div className="mt-4 w-full rounded-lg bg-gray-100 p-0.5">
      <div className="flex w-full items-center gap-1">
        <button
          onClick={handlePrevious}
          disabled={selectedIndex === 0}
          className="flex h-10 w-10 cursor-pointer items-center justify-center rounded-lg bg-white hover:bg-gray-50 disabled:cursor-not-allowed disabled:opacity-50"
        >
          <ArrowLeftIcon />
        </button>

        <div className="max-w-full flex-1 rounded-lg bg-white px-4 py-2 text-center font-medium">
          {type !== blokTestConst.testTypes.TOPIC_TEST && (
            <span className="text-xs text-gray-400 mr-1">
              {selectedIndex + 1}. {labelPrefix} -
            </span>
          )}
          <span className="max-w-53 inline-block truncate align-middle"> {options[selectedIndex]?.label}</span>
        </div>

        <button
          onClick={handleNext}
          disabled={selectedIndex === options.length - 1}
          className="flex h-10 w-10 cursor-pointer items-center justify-center rounded-lg bg-white hover:bg-gray-50 disabled:cursor-not-allowed disabled:opacity-50"
        >
          <ArrowRightIcon />
        </button>
      </div>
    </div>
  );
};

export default Segmented;
